var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":_vm.type,"disabled":!_vm.enabled,"variant":_vm.variant},on:{"click":_vm.clickHandler}},[(_vm.running)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }